import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { POST , GET } from "../../helpers/apiHelper";
import * as action from "./actions";
// import { storeLog } from "../log/actions";
import {
  setCurrentToken,
  setCurrentUser,
  setCurrentMunicipal,
  setCurrentRefreshToken,
  logout
} from "../../helpers/utility";
import { ROLE } from "../../constant/constant"; 

const loginAsync = async (payload) => POST(`/auth/login`, payload);

function* login({ payload }) {
  try {
    const token = yield call(loginAsync, payload?.user);
    setCurrentToken(token?.accessToken);
    setCurrentRefreshToken(token?.refreshToken);
    setCurrentUser(token?.data);
    setCurrentMunicipal(token?.data?.municipal);

    const redirectDefault = ROLE[token?.data?.role]?.defaultRedirect;
    window.location.href = `/${redirectDefault}`;
  } catch (error) {
    yield put(
      action.loginUserError(`${error?.response?.data?.message || error}`)
    );
  }
}

function* refreshTokenSaga({ payload }){
  try { 
    const result = yield call(async(query) => GET(`/auth/refresh-token`,{}));

    if(result && result.status === 401)
      yield put(logout({})); 


       
    if(result && result.status === 200){
      setCurrentToken(result?.data?.accessToken)
      yield put(action.refreshNewTokenSuccess(null)) 
    }

  } catch (error) {
      alert(error.message)
      yield put(logout({}));
  }
}

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(action.LOGIN_USER, login);
}

export default function* rootSaga() {
  yield all([fork(watchLoginUser)]);

  // SIMPLIFY
  yield all([takeEvery(action.AUTH_REFRESH_TOKEN, refreshTokenSaga)]);
}
